import { Box, Table, Text, Thead, Tr, Th, Tbody, Td, Button, Select, Flex, Input, Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import { Layout } from "../../GlobalComponent/Layout/Layout";
import { useEffect, useState } from "react";
import { subscriptionDetails } from "../../Http/Index";
import OfflinePayment from "./components/OfflinePayment";

export const Subscriber = () => {
    const [data, setData] = useState<any>(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        startDate: "",
        endDate: "",
        registrationStartDate: "",
        registrationEndDate: "",
        subscriptionActive: "",
        paymentType: ""
    });
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit, filters]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const params: any = { page, limit };
            if (filters.startDate) params.startDate = filters.startDate;
            if (filters.endDate) params.endDate = filters.endDate;
            if (filters.registrationStartDate) params.registrationStartDate = filters.registrationStartDate;
            if (filters.registrationEndDate) params.registrationEndDate = filters.registrationEndDate;
            if (filters.subscriptionActive) params.subscriptionActive = filters.subscriptionActive;
            if (filters.paymentType) params.paymentType = filters.paymentType;

            const response = await subscriptionDetails(params);
            setData(response.data);
        } catch (error) {
             alert("Failed to fetch subscription details. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    const formatDate = (date: string | null) => {
        if (!date) return "N/A";
        return new Date(date).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
    };

    const formatTimestamp = (timestamp: string | number | null) => {
        if (timestamp === null || timestamp === undefined) return "N/A";

        const seconds =
            typeof timestamp === "string" ? Number(timestamp) : timestamp;

        if (isNaN(seconds)) return "N/A";

        const milliseconds = seconds * 1000;

        return new Date(milliseconds).toLocaleDateString("en-IN", {
            timeZone: "Asia/Kolkata",
        });
    };


    return (
        <Layout>
            <Box p={6}>
                <Tabs defaultIndex={0}>
                    <TabList>
                        <Tab>B2C Subscription Details</Tab>
                        <Tab>Offline Payment</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel>
                            <Text fontSize="2xl" textAlign="center" fontWeight="bold" mb={4}>
                                B2C Subscription Details
                            </Text>

                            <Flex mb={4} gap={4} align="center" wrap="wrap">
                    <Button
                        onClick={() => setPage((prev) => Math.max(1, prev - 1))}
                        isDisabled={page === 1 || isLoading}
                    >
                        Previous
                    </Button>

                    <Text>Page {page}</Text>

                    <Button
                        onClick={() => setPage((prev) => prev + 1)}
                        isDisabled={isLoading || !data?.data?.length || data.data.length < limit || page * limit >= (data?.total || 0)}
                    >
                        Next
                    </Button>


                    <Select
                        w="100px"
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        {[10, 20, 50, 100].map((opt) => (
                            <option key={opt} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </Select>
                    <Text>Total: {data?.total || 0}</Text>

                    <Flex align="center" gap={2} px={3} py={2} border="1px solid" borderColor="gray.200" borderRadius="md" bg="white">
                        <Text fontSize="sm" color="gray.600">Expiry Date</Text>
                        <Input
                            size="sm"
                            type="date"
                            value={filters.startDate}
                            onChange={(e) => {
                                setFilters((prev) => ({ ...prev, startDate: e.target.value }));
                                setPage(1);
                            }}
                        />
                        <Text fontSize="sm" color="gray.500">→</Text>
                        <Input
                            size="sm"
                            type="date"
                            value={filters.endDate}
                            onChange={(e) => {
                                setFilters((prev) => ({ ...prev, endDate: e.target.value }));
                                setPage(1);
                            }}
                        />
                    </Flex>
                    <Flex align="center" gap={2} px={3} py={2} border="1px solid" borderColor="gray.200" borderRadius="md" bg="white">
                        <Text fontSize="sm" color="gray.600">Registration Date</Text>
                        <Input
                            size="sm"
                            type="date"
                            value={filters.registrationStartDate}
                            onChange={(e) => {
                                setFilters((prev) => ({ ...prev, registrationStartDate: e.target.value }));
                                setPage(1);
                            }}
                        />
                        <Text fontSize="sm" color="gray.500">→</Text>
                        <Input
                            size="sm"
                            type="date"
                            value={filters.registrationEndDate}
                            onChange={(e) => {
                                setFilters((prev) => ({ ...prev, registrationEndDate: e.target.value }));
                                setPage(1);
                            }}
                        />
                    </Flex>

                    <Select
                        w="180px"
                        placeholder="Payment Type"
                        value={filters.paymentType}
                        onChange={(e) => {
                            setFilters((prev) => ({ ...prev, paymentType: e.target.value }));
                            setPage(1);
                        }}
                    >
                        <option value="online">Online</option>
                        <option value="offline">Offline</option>
                    </Select>

                    <Select
                        w="180px"
                        placeholder="Subscription Active"
                        value={filters.subscriptionActive}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                                setFilters((prev) => ({ ...prev, subscriptionActive: "" }));
                            } else {
                                setFilters((prev) => ({ ...prev, subscriptionActive: value }));
                            }
                            setPage(1);
                        }}
                    >
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </Select>

                    <Button
                        colorScheme="gray"
                        variant="outline"
                        onClick={() => {
                            setFilters({
                                startDate: "",
                                endDate: "",
                                registrationStartDate: "",
                                registrationEndDate: "",
                                subscriptionActive: "",
                                paymentType: ""
                            });
                            setPage(1);
                        }}
                    >
                        Clear Filters
                    </Button>



                            </Flex>

                            <Box borderWidth={1} borderRadius="lg" overflowX="auto">
                    <Table variant="simple">
                        <Thead bg="gray.100">
                            <Tr cursor="auto">
                                <Th>SrNo</Th>
                                <Th>Name</Th>
                                <Th>Email</Th>
                                <Th>Phone Number</Th>
                                <Th>Reached Payment</Th>
                                <Th>Payment Status</Th>
                                <Th>Invoice Date</Th>
                                <Th>Subscription Expiry Date</Th>
                                <Th>Subscription Active</Th>
                                <Th>Payment Date</Th>
                                <Th>Registration Date</Th>
                                <Th>Payment Type</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data?.data && data.data.length > 0 ? (
                                data.data.map((item: any, ind: number) => (
                                    <Tr key={ind} cursor="auto">
                                        <Td>{(page - 1) * limit + ind + 1}</Td>
                                        <Td>{item.name || "N/A"}</Td>
                                        <Td>{item.emailId || "N/A"}</Td>
                                        <Td>{item.phoneNumber || "N/A"}</Td>
                                        <Td>{item.reachedPayment ? "Yes" : "No"}</Td>
                                        <Td>{item.paymentStatus || "N/A"}</Td>
                                        <Td>{formatDate(item.subscriptionCreationDate)}</Td>
                                        <Td>{formatDate(item.subscriptionExpiryDate)}</Td>
                                        <Td>{item.subscriptionActiveFlag ? "Yes" : "No"}</Td>
                                        <Td>{formatTimestamp(item.razorpayPaymentOrderDate)}</Td>
                                        <Td>{formatDate(item.registrationDate)}</Td>
                                        <Td>{item.paymentType || "N/A"}</Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan={12} textAlign="center">
                                        {isLoading ? "Loading..." : "No data available"}
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                            </Box>
                        </TabPanel>

                        <TabPanel>
                            <OfflinePayment />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </Layout>
    );
};